import { toHTML } from "@portabletext/to-html";
import { ArticleCardCarouselProps } from "@bluebottlecoffee/design-system/components";
import { ArticleCardCarousel as Schema } from "../sanity-schema";
import { toArticleCardProps } from "./article-card";
import { toLinkProps } from "./link";
import { trackEvent } from "../segment/track-event";
import { isHomePage, stripHtmlTags } from "../utils";

export function toArticleCardCarouselProps(
  data: Schema,
  region: string,
  lang: string,
): ArticleCardCarouselProps {
  const parsedHeadline = data?.headline ? toHTML(data.headline[lang]) : "";
  return {
    ...(data.bgColor && { bgColor: data.bgColor }),
    ...(data.cta &&
      data.cta.text && {
        cta: {
          ...toLinkProps(data.cta, region, lang),
          onClick: () => {
            if (isHomePage(lang, region)) {
              trackEvent("homepage_cta", {
                heading: stripHtmlTags(parsedHeadline),
                cta_name: data.cta.text[lang],
              });
            }
          },
        },
      }),
    headline: parsedHeadline,
    articleCards: data.articleCards.map((c) =>
      toArticleCardProps(c, region, lang),
    ),
  };
}
